
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[pageLocale]/companies/[companySlug]/newsfeed/[articleSlug]",
      function () {
        return require("private-next-pages/[pageLocale]/companies/[companySlug]/newsfeed/[articleSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[pageLocale]/companies/[companySlug]/newsfeed/[articleSlug]"])
      });
    }
  